export function parseLooseDate(raw) {
  if (!raw) return null;
  if (raw instanceof Date && !Number.isNaN(raw.getTime())) return raw;
  const str = String(raw).trim();
  if (!str) return null;

  // Unambiguous dd/mm/yyyy (and yy) before Date.parse — avoids US mm/dd interpretation.
  const slash = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
  if (slash) {
    const day = Number(slash[1]);
    const month = Number(slash[2]);
    const year = Number(slash[3].length === 2 ? `20${slash[3]}` : slash[3]);
    const parsed = new Date(year, month - 1, day);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const isoParsed = new Date(str);
  if (!Number.isNaN(isoParsed.getTime())) return isoParsed;

  return null;
}

export function formatLooseDate(raw, locale, options = {}) {
  const parsed = parseLooseDate(raw);
  if (!parsed) return '';
  return parsed.toLocaleDateString(locale, options);
}

export function extractMarginParts(marginRaw) {
  if (!marginRaw) return { dateChunk: '', timeChunk: '' };
  const parts = String(marginRaw).trim().split(/\s*\|\s*/).map((x) => x.trim()).filter(Boolean);
  if (parts.length >= 2) return { dateChunk: parts[0], timeChunk: parts[1] };
  const single = parts[0] || '';
  if (!single) return { dateChunk: '', timeChunk: '' };
  if (/^\d{1,2}:\d{2}\s*-\s*\d{1,2}:\d{2}$/.test(single)) {
    return { dateChunk: '', timeChunk: single };
  }
  // e.g. "13/05/2026 10:00 - 12:00" or "06/05/2026 - 07/05/2026 10:00 - 11:00" (no "|")
  const tailTime = /^(.+?)\s+(\d{1,2}:\d{2}\s*-\s*\d{1,2}:\d{2})$/.exec(single);
  if (tailTime) {
    return { dateChunk: tailTime[1].trim(), timeChunk: tailTime[2].trim() };
  }
  return { dateChunk: single, timeChunk: '' };
}

export function extractMarginDateChunk(marginRaw) {
  const { dateChunk } = extractMarginParts(marginRaw);
  if (!dateChunk || /^\d{1,2}:\d{2}/.test(dateChunk)) return '';
  if (dateChunk.includes(' - ')) return dateChunk.split(' - ')[0].trim();
  return dateChunk;
}
